import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaTasks, FaWallet } from 'react-icons/fa';
import { TbHomeDollar } from "react-icons/tb";
import { IoNotifications } from "react-icons/io5";
import { IoIosChatbubbles } from "react-icons/io";
import { logo } from '../assets';

const screens = [
  { id: 2, link: '/', name: 'Home', icon: <TbHomeDollar size={24} /> },
  { id: 1, link: '/tasks', name: 'Tasks', icon: <FaTasks size={24} /> },
  { id: 3, link: '/wallet', name: 'Wallet', icon: <FaWallet size={22} /> },
  { id: 4, link: '/notifications', name: 'Notifications', icon: <IoNotifications size={24} /> },
  { id: 5, link: `https://t.me/thirtify`, name: 'Chat', icon: <IoIosChatbubbles size={24} /> },
];

const mobile = [
  { id: 4, link: '/notifications', name: 'Notifications', icon: <IoNotifications size={24} /> },
  { id: 5, link: `https://t.me/thirtify`, name: 'Chat', icon: <IoIosChatbubbles size={24} /> },
];

const TopNav = () => {
  const location = useLocation();
  const [active, setActive] = useState("");

  useEffect(() => {
    setActive(getActiveLink(location.pathname));
  }, [location.pathname]); // Updates when the route changes

  function getActiveLink(pathname) {
    if (pathname.startsWith('/levels') || pathname.startsWith('/agents') ||
      pathname.startsWith('/referral') || pathname.startsWith('/transacts') ||
      pathname.startsWith('/groups')) {
      return 'Home';
    }
    const link = screens.find((nav) => nav.link === pathname);
    return link ? link.name : "";
  }

  return (
    <div className='flex bg- white shadow-zinc-200 drop-shadow'>
      <div className="flex items-center justify-between 2xl:w-[1480px] max-xl:w-[1280px] lg:w-[1080px] max-md:w-full mx-auto p-2 h-[60px] w-full max-md:ml-1 max-md:mr-2">
        <Link to="/" className="h-[40px] w-[40px]">
          <img src={logo} alt='Thirtify' className='h-[40px] w-[40px] object-cover' />
        </Link>

        <div className='flex gap-10 items-center'>
          {screens.map((nav) => (
            <Link to={nav.link} key={nav.id} target={nav.id === 5 && '_blank'} className='max-md:hidden'>
              <ul className='cursor-pointer relative group'>
                {React.cloneElement(nav.icon, {
                  className: `text-[24px] ${active === nav.name ? "text-rose-500 hover:text-rose-400" : "text-zinc-400 hover:text-zinc-500"}`
                })}
                {/* Tooltip */}
                <div className="absolute bottom-[-40px] left-1/2 transform -translate-x-1/2 whitespace-nowrap px-2 py-1 bg-rose-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  {nav.name}
                </div>
              </ul>
            </Link>
          ))}
          <div className='flex gap-5 md:hidden'>
            {mobile.map((nav) => (
              <Link to={nav.link} key={nav.id} target={nav.id === 5 && '_blank'} className='md:hidden'>
                <ul className='cursor-pointer relative group'>
                  {React.cloneElement(nav.icon, {
                    className: `text-[24px] ${active === nav.name ? "text-rose-500 hover:text-rose-400" : "text-zinc-400 hover:text-zinc-500"}`
                  })}
                </ul>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopNav;